import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BookingService } from 'src/app/services/api/booking.service';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
// import { CommonService } from 'src/app/services/api/common.service';
import { NgxUiLoaderService } from "ngx-ui-loader"; // Import NgxUiLoaderService
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { NgClass, CommonModule } from '@angular/common';
// import { After } from 'v8';

import { DirectivesModule } from 'src/app/directives.module';
import { SchoolData } from 'src/app/models/schoolUser';

@Component({
  selector: 'app-inline-calendar',
  templateUrl: './inline-calendar.component.html',
  styleUrls: ['./inline-calendar.component.scss'],

  standalone: true,
  imports: [CommonModule, NgClass, DirectivesModule]
})
export class InlineCalendarComponent implements OnInit {


  title?: string;
  closeBtnName?: string;
  teacher: any;
  inlineEndDate: any;
  date: any;

  @Input() availability: any;
  @Input() teacherID: any;
  @Input() from: any
  @Output() onDatePicked = new EventEmitter<any>();
  @Input() isVisiblePrintStatus: boolean = false;
  @Input() isShowPrintStatus: boolean = false;
  @Input() school_id: any;

  nextPrevForm: FormGroup = this.fb.group({
    providerId: [''],
    date: [''],
  });
  dateList: any;
  monthsShown: any;
  public schoolProps!: SchoolData;
  constructor(public bsModalRef: BsModalRef,
    private fb: FormBuilder,
    private bookingService: BookingService,
    private ngxService: NgxUiLoaderService,
    private toastr: ToastrService,
    public router: Router) {

    this.inlineEndDate = new Date();
  }


  ngOnInit(): void {
    this.schoolProps = JSON.parse(localStorage.getItem("userData") || '{}');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isVisiblePrintStatus']) {
      // console.log('isVisiblePrintStatus changed:', changes['isVisiblePrintStatus'].currentValue);
      this.isShowPrintStatus = changes['isVisiblePrintStatus'].currentValue;
    }
  }

  // getFormControlValues(){
  //   return this.nextPrevForm.value;
  // }
  // addDays(date: any,id:any) {
  //   var momentObj = moment(date, 'DD/MM/YYYY');
  //   alert(momentObj.add(14, 'd').format('DD/MM/YYYY'))
  //   this.nextPrevForm.patchValue({
  //     date: momentObj.add(14, 'd').format('DD/MM/YYYY'),
  //     providerId:id
  //   });
  //   // return momentObj.add(14, 'd').format('DD/MM/YYYY')
  // }

  // substractDays(date: any,id:any) {
  //   var momentObj = moment(date, 'DD/MM/YYYY');
  //   alert(momentObj.subtract(14, 'd').format('DD/MM/YYYY'))
  //   this.nextPrevForm.patchValue({
  //     date: momentObj.subtract(14, 'd').format('DD/MM/YYYY'),
  //     providerId:id
  //   });
  // }

  // prevClick(id: any) {
  //   this.setPrevNxtData(this.inlineEndDate, true, 2, id);
  // }

  // nextClick(id: any) {
  //   this.setPrevNxtData(this.inlineEndDate, true, 1, id);
  // }

  setPrevNxtData(res: any, apiCall: boolean, sendDate: number, id: any) {
    // Set Next Prev Api Call
    if (apiCall) {
      this.ngxService.start();
      //  1 for nextfortnight
      //  2 for previousfortnight
      if (sendDate == 1) {
        this.inlineEndDate.setDate(this.inlineEndDate.getDate() + 14);
        this.nextPrevForm.patchValue({
          date: moment(this.inlineEndDate).format('DD/MM/YYYY'),
          providerId: [id]
        });
      } else if (sendDate == 2) {
        this.inlineEndDate.setDate(this.inlineEndDate.getDate() - 14);
        this.nextPrevForm.patchValue({
          date: moment(this.inlineEndDate).format('DD/MM/YYYY'),
          providerId: [id]
        });
      }
      if(this.schoolProps?.properties?.is_parent_school) {
        if (!this.nextPrevForm.contains('school_id')) {
          this.nextPrevForm.addControl('school_id', this.fb.control(''));
        }
        this.nextPrevForm.patchValue({
          school_id: this.school_id
        });
      } else {
        this.nextPrevForm.removeControl('school_id');
      }
      this.bookingService.nextPrevFortAPI(this.nextPrevForm.value).subscribe({
        next: (res: any) => {
          this.availability = res.data[0].availability
          this.monthsShown = res.date_month;
          this.ngxService.stop();
        },
        error: (err: any) => {
          console.log(err);
          this.ngxService.stop();
        }
      })
    }
  }
  nextFortnight() {
    this.setPrevNxtData(this.inlineEndDate, true, 1, this.teacherID);
  }

  prevFortnight() {
    this.setPrevNxtData(this.inlineEndDate, true, 2, this.teacherID);
  }

  //    getStatusClass(status: string): string {
  //   switch (status) {
  //     case 'available':
  //       return 'available';
  //     case 'haventindicated':
  //       return 'haventindicated';
  //     default:
  //       return 'unavailable';
  //   }
  // }

  // getStatusLabel(status: string): string {
  //   switch (status) {
  //     case 'available':
  //       return 'A';
  //     case 'haventindicated':
  //       return 'HI';
  //     default:
  //       return 'U';
  //   }
  // }
  getStatusLabel(status: string, day: any): string {
    // console.log('Getting status label for:', status);
    switch (status) {
      case 'haventindicated': return 'HI'; // Haven’t Indicated
      case 'booked': return 'B';   // Booked
      case 'booked_c': return 'B';   // Booked Child
      case 'unavailable': return 'UA'; // Unavailable
      case 'available': return 'A';   // Available
      case 'booked_externally': return 'BE'; // Booked Elsewhere
      case 'lrt_contract': return 'L'; // LRT Contract
      case 'drt_contract': return 'D'; // DRT Contract
      default: return '';
    }
  }

  

  getStatusClass(status: string): string {
    
    switch (status) {
      case 'haventindicated': return 'status-hi';
      case 'booked': return 'status-b';
      case 'booked_c': return 'status-b-child';
      case 'unavailable': return 'status-ua';
      case 'available': return 'status-a';
      case 'booked_externally': return 'status-be';
      case 'lrt_contract': return 'status-lrt';
      case 'drt_contract': return 'status-drt';
      default: return '';
    }
  }

  addDays(date: any) {
    var currentDate = date;
    var momentObj = moment(currentDate, 'DD/MM/YYYY');
    return momentObj.add(14, 'd').format('DD/MM/YYYY')
  }

  substractDays(date: any) {
    var currentDate = date;
    var momentObj = moment(currentDate, 'DD/MM/YYYY');
    return momentObj.subtract(14, 'd').format('DD/MM/YYYY')
  }
}
